"use strict";

var _classCallCheck = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AsyncLib = /*#__PURE__*/function () {
  function AsyncLib(asyncKey, scope) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, AsyncLib);
    this.asyncKey = asyncKey;
    this.scope = scope;
    this.retryCount = 0;
    this.timeout = options.timeout || 1000;
    this.retryLimit = options.retryLimit || 30;
    this.customTest = options.customTest;
  }
  _createClass(AsyncLib, [{
    key: "get",
    value: function get() {
      var _this = this;
      var lib = this.scope[this.asyncKey];
      if (this.libTest(lib)) {
        return Promise.resolve(lib);
      } else if (!this.pendingDataLayer) {
        this.pendingDataLayer = new Promise(function (resolve, reject) {
          _this.timer = setInterval(function () {
            var lib = _this.scope[_this.asyncKey];
            _this.retryCount++;
            if (_this.libTest(lib)) {
              if (_this.timer) clearInterval(_this.timer);
              return resolve(lib);
            }
            if (_this.retryCount > _this.retryLimit) {
              if (_this.timer) clearInterval(_this.timer);
              var error = Error("Unable to connect to \"".concat(_this.asyncKey, "\" after ").concat(_this.retryLimit, " attempts"));
              reject(error);
            }
          }, _this.timeout);
        });
      }
      return this.pendingDataLayer;
    }
  }, {
    key: "libTest",
    value: function libTest(lib) {
      return lib && (!this.customTest || this.customTest(lib));
    }
  }]);
  return AsyncLib;
}();
exports.AsyncLib = AsyncLib;